import ctl from "@netlify/classnames-template-literals";

export const header = ctl(`
  z-10
  flex
  items-center
  justify-between
  bg-white
  p-6
  md:hidden
`);

export const headerDark = ctl(`
  ${header}
  !bg-purple-950
  !border-b
  !border-purple-900
`);
